import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { colors, device, getTypographyFontStyle } from "../../styles/global.style";
import Button from "../../components/Button/Button";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 48px 24px;
  margin-top: 100px;
  text-align: center;

  @media ${device.md} {
    min-height: 50vh;
    margin-top: 120px;
  }
`;

const ErrorCode = styled.h1`
  font-family: "Poppins", sans-serif;
  font-size: 100px;
  font-weight: 800;
  color: ${colors.primary};
  margin: 0;
  line-height: 1;
  letter-spacing: -4px;
  background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media ${device.md} {
    font-size: 160px;
    letter-spacing: -8px;
  }
`;

const Title = styled.h2`
  ${getTypographyFontStyle({ variant: "h1", weight: 600 })};
  color: ${colors.dark};
  margin: 16px 0 12px;
`;

const Description = styled.p`
  ${getTypographyFontStyle({ variant: "body1", weight: 400 })};
  color: ${colors.lightdark};
  max-width: 480px;
  margin: 0 auto 32px;
  line-height: 1.7;
`;

export default function NotFound() {
  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = "Page Not Found — Trixie Group";
  }, []);

  return (
    <Container>
      <ErrorCode>404</ErrorCode>
      <Title>Page Not Found</Title>
      <Description>
        Sorry, the page you're looking for doesn't exist or has been moved.
        Let's get you back on track.
      </Description>
      <Button
        onClick={() => navigate("/")}
        label="BACK TO HOME"
        size="large"
      />
    </Container>
  );
}
